import { render, staticRenderFns } from "./table.purchase.vue?vue&type=template&id=bbc2b71e"
import script from "./table.purchase.vue?vue&type=script&lang=js"
export * from "./table.purchase.vue?vue&type=script&lang=js"
import style0 from "./table.purchase.vue?vue&type=style&index=0&id=bbc2b71e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports